// Figuren-Outfits für Kapitel 5 (Palettenfarben aus art/palette.ts).
import { P } from '../art/palette.ts';
import type { Outfit } from './character.ts';

export const OUTFITS_CH5: Record<string, Outfit> = {
  /** Moderatorin und Turnierleiterin Frauke Lorenzen */
  frauke: { coat: P.red2, pants: P.night1, hair: P.amber2, skin: P.skin2, boots: P.ink, scarf: P.brass2 },
  /** Schaustellerin Wilma am Riesenrad */
  wilma: { coat: P.green1, pants: P.wood2, hair: P.red2, skin: P.skin1, boots: P.wood0, scarf: P.amber1, hat: P.red1 },
  /** Bühnentechniker Bodo */
  bodo: { coat: P.iron1, pants: P.ink, hair: P.wood0, skin: P.skin1, boots: P.ink, hat: P.ink, beard: P.wood1 },
  /** Chorleiter des Shanty-Chors */
  hein: { coat: P.sea0, pants: P.night1, hair: P.plaster2, skin: P.skin2, boots: P.ink, hat: P.white, beard: P.plaster2, scarf: P.red1 },
  /** Hauke Dittmers, Wirt der „Goldenen Makrele“ (eigene ID für Kapitel 5) */
  dittmers5: { coat: P.brass1, pants: P.wood1, hair: P.wood3, skin: P.skin2, boots: P.wood0, scarf: P.sea1 },
  /** Kapitän Pieper (Kapitel-5-Variante) */
  pieper5: { coat: P.night1, pants: P.iron0, hair: P.iron2, skin: P.skin1, boots: P.ink, hat: P.night0, beard: P.iron2, scarf: P.white },
  /** Ilse von Möwensand (Kapitel-5-Variante) */
  ilse5: { coat: P.sea1, pants: P.wood1, hair: P.white, skin: P.skin2, boots: P.wood0, scarf: P.amber2 },
};
